import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';
import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { Ppm } from '@/types';

interface getPpmDataTableStructureProps {
  store: PpmRepository;
  createAction?: () => void;
  rowActionsFn?: (target: Ppm) => DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getPpmDataTableStructure = ({ store, createAction, rowActionsFn, serverQuery }: getPpmDataTableStructureProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.name',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const yearColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.year',
    accessorKey: 'annee',
    variant: DataTableColumnVariant.TEXT,
  };

  const processStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.processStep',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (!value) return { value: 'Non défini', class: 'opacity-70' };
      return { value };
    },
  };

  const acColumnn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.ac',
    accessorKey: 'ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'ppm.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: `ppm.status.${value}` };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'primary';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'PUBLIE') return 'info';
        return 'danger';
      },
    },
  };

  const budgetColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.budget',
    accessorKey: 'budgetEstime',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: number) => {
      if (value) {
        return { value: value };
      }
      return { value: 'Non défini', class: 'opacity-70' };
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'ppm.table.created_at',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'ppm.table.updated_at',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  // const createdByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'ppm.table.created_by',
  //   accessorKey: 'metadata.createdBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };
  //
  // const updatedByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'ppm.table.updated_by',
  //   accessorKey: 'metadata.updatedBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  return {
    singular: 'ppm.singular',
    plural: 'ppm.plural',
    columns: [refColumn, acColumnn, yearColumn, statusColumn, processStepColumn, budgetColumn, createdAtColumn, updatedAtColumn], // Removed createdByColumn, updatedByColumn , budgetColumn
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    target: (row: Ppm) => {
      store.set('response', row);
      store.set('dto', row);
    },
    rowActionsFn,
    searchableFields: ['ref', 'annee', 'status'],
    enableServerActions: true,
    serverQuery,
  };
};
